export enum SharingConfigKey {
  'DEFAULT_TEAM' = 'DEFAULT_TEAM',
  'NYLAS_SECURITY_WORD' = 'NYLAS_SECURITY_WORD',
}
